export default "__VITE_ASSET__C_KLhxM8__"